import React from 'react'
import OrangeCheckboxIcon from '../../assets/img/orange-checkbox-icon.svg'
import YellowCheckboxIcon from '../../assets/img/yellow-checkbox-icon.svg'
import PurpleCheckboxIcon from '../../assets/img/purple-checkbox-icon.svg'
import BlueCheckboxIcon from '../../assets/img/blue-checkbox-icon.svg'
import grayCheckboxIcon from '../../assets/img/gray-checkbox-icon.svg'
import { useEffect, useState } from "react";
import { hideLoader, showLoader } from '../../components/loader';
import { Alert } from "react-bootstrap";
import { useDispatch, useSelector } from "react-redux";
import { toast } from 'react-toastify';
import { apiUrl } from "../../utils/url";
import { useHistory } from 'react-router-dom';
import SideBar from '../side-bar';
import PageHeader from '../page-header';
import tickIcon from "../../assets/img/white-tick.svg";
import { audiencePosts as manageStripePost } from '../../services/postRequests/audience'
import lifetime from "../../assets/img/lifetime.svg"

const NewUpgradePage = () => {

    const [error, setError] = useState([])
    const history = useHistory()
    const { slug } = useSelector(state => state?.slugReducer);
    const newUser = useSelector(state => state?.newUserReducer);
    const pro = useSelector(state => state?.proReducer);
    const planType = useSelector(state => state?.plantypeReducer);
    const [monthlyPlan, setMonthlyPlan] = useState(true)
    const [yearlyPlan, setYearlyPlan] = useState(false)
    const [monthlyPlan2, setMonthlyPlan2] = useState(true)
    const [yearlyPlan2, setYearlyPlan2] = useState(false)
    function togglePlans(e) {
        const selectedValue = e.target.value;
        if (selectedValue === 'yearly') {
            setYearlyPlan(true)
            setMonthlyPlan(false)
        } else if (selectedValue === 'monthly'){
            setMonthlyPlan(true)
            setYearlyPlan(false)
        }
    }
    function togglePlans2(e,value) {
        console.log("value",value);
        const selectedValue = e?.target?.value ?? value;
        if (selectedValue === 'yearly') {
            setYearlyPlan2(true)
            setMonthlyPlan2(false)
        } else if (selectedValue === 'monthly'){
            setMonthlyPlan2(true)
            setYearlyPlan2(false)
        }
    }
    const handleSubmit = (e,type) => {
        showLoader();
        setError([])
        var myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)

        const formdata = new FormData();
        formdata.append('project',slug);
        formdata.append('type',type);
        formdata.append('plan_type',e.target.name);
        formdata.append("tolt_referral", window.tolt_referral??'');
        var requestOptions = {
            method: 'POST',
            headers: myHeaders,
            body: formdata,
            redirect: 'follow'
        };

        fetch(apiUrl + "/subscribe-plan", requestOptions)
            .then(async (res) => {
                hideLoader()
                const response = await res?.json();
                if (response?.status_code == 200) {

                        location.href = response?.data?.url;

                        localStorage.setItem("temp_slug",response?.data?.slug);
                        localStorage.setItem("last_activity", `/project/${response?.data?.slug}/campaigns`)
                        localStorage.setItem("plan_type",e.target.name)
                        localStorage.setItem("period",type)
                }
                else {
                    setError(getErrors(response?.errors))
                    toast.error(response?.status_message)
                }
            }).catch((err) => hideLoader())

           

    }

    const manageStripe = (e) => {
        showLoader()
        const myHeaders = new Headers();
        myHeaders.append("Authorization", `Bearer ${localStorage?.getItem("token")}`)
        const formdata = new FormData()
        formdata.append("project", slug)
        const api = apiUrl + `/manage-subscription`;
        const setOptions = {
            method: "POST",
            body: formdata,
            headers: myHeaders
        }
        manageStripePost(api, hideLoader, setOptions).then((response) => {
            if (response) {
                location.href = response?.url
                showLoader()
            }
        })
    }
    return (
        // <div id="wrapper">
            <div className='up-cont-u'>
            
            {/* from="zaap-upgrade" */}
            {/* <div class="community-main"> */}
                {/* <SideBar from="zaap-upgrade"/> */}
                    <div className='choose-plan-container upgrade-card'>
                        <div className="plan-text-container">
                            <h1 className='settings-section-heading'>
                                Upgrade
                            </h1>
                            {/* <div className='choose-plan-type'>
                            <div class="up-in-toggle bg-f1f1f1 schedule-toggle w-50 btn-semi-rounded" style={{ padding: "5px 3px" }}>
                                    <input type="radio" id="text_align_left" name="scheduleTime" onChange={togglePlans} checked={monthlyPlan} style={{ display: "none" }}  value={"monthly"} />
                                    <label for="text_align_left" class="btn-semi-rounded newsletter-btn-semi-rounded " > <span className='choose-plan-type-text'> Monthly</span></label>
                                    <input type="radio" id="text_align_right" name="scheduleTime" onChange={togglePlans} checked={yearlyPlan} style={{ display: "none" }} value={"yearly"}  />
                                    <label for="text_align_right" class="btn-semi-rounded newsletter-btn-semi-rounded "  > <span className='choose-plan-type-text'> Yearly</span></label>
                                </div>
                            </div> */}
                            <div class="plan-box">
                                <svg className='mobsvg' fill="none" viewBox="0 0 387 133" xmlns="http://www.w3.org/2000/svg"><path d="m0 126.9c97.123 0 275.14 8.118 382-122.9" stroke="url(#a)" stroke-width="11"/><defs><linearGradient id="a" x1="310.58" x2="61.054" y1="105.93" y2="112.1" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBA34" offset="0"/><stop stop-color="#18f" offset=".49745"/><stop stop-color="#5F5F5F" offset="1"/></linearGradient></defs></svg>
                                <svg className='tabsvg' xmlns="http://www.w3.org/2000/svg" width="700" height="130" viewBox="0 0 700 130" fill="none"><path d="M0 124.353C179.5 124.353 508.5 132.5 706 1" stroke="url(#paint0_linear_2452_15450)" stroke-width="11"/><defs><linearGradient id="paint0_linear_2452_15450" x1="574.013" y1="103.3" x2="113.513" y2="124.289" gradientUnits="userSpaceOnUse"><stop stop-color="#FFBA34"/><stop offset="0.177083" stop-color="#F5DB85"/><stop offset="0.333333" stop-color="#A0D9DF"/><stop offset="0.497448" stop-color="#1188FF"/><stop offset="1" stop-color="#5F5F5F"/></linearGradient></defs></svg>
                                <div className='plancircle graycrcle'>
                                    {!pro && <img src={tickIcon} alt="" />}
                                </div>
                                <div className='plancircle bluecrcle'>
                                    {pro && planType != "ultra" && <img src={tickIcon} alt="" />}
                                </div>
                                <div className='plancircle yellowcrcle'>
                                    {pro && planType == "ultra" && <img src={tickIcon} alt="" />}
                                </div>
                            </div>
                            {/* {(pro != 1 && pro != true) &&
                            <div className=' mt-3 activate-profile'>
                                To Activate Your Profile, Join Any Plan
                            </div>
                            } */}
                        </div>
                        {monthlyPlan &&
                            <div className='plan-cards-container'  id="monthly-plans">
                                {/* free plan */}
                                 <div className='plan-card grey-box-shadow'>
                                    <div>
                                        <div className='card-text-container'>
                                            <h3 className='plan-card-period cardhead-u mb-1'>Free</h3>
                                            <h1 className='mb-0 plan-card-price price-u'>$0/mo</h1>
                                        </div>
                                        <div className='features-main-container'>
                                            <div className='features-list-container'>
                                            <div className='plan-feature-list'>
                                                    <img src={grayCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>100 Credits</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={grayCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>1 Lead = 1 credit</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={grayCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Pre-Made Templates</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='features-main-container'>
                                        <div className='plan-button-container'>
                                        {!pro ?
                                            <button className='plan-trial-button blue-button clr-gray'>Current Plan</button>
                                            :
                                            <button name="basic" className='plan-trial-button blue-button clr-gray' onClick={manageStripe}>Downgrade to Free</button>
                                        }
                                        </div>
                                    </div>
                                </div>
                                {/* pro plan */}
                                <div className='plan-card blue-box-shadow'>
                                    <div>
                                        <div className='card-text-container'>
                                            <h3 className='plan-card-period cardhead-u mb-1'>Starter</h3>
                                            <h1 className='mb-0 plan-card-price price-u'>$29/mo</h1>
                                        </div>
                                            <div className='features-list-container'>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>1000 Credits</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>1 Lead = 1 credit</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Pre-Made Templates</p>
                                                </div>
                                            </div>
                                    </div>
                                    <div className='features-main-container'>
                                        <div className='plan-button-container'>
                                        {(pro == 1 || pro == true) && (planType == 'pro' || !planType) ? 
                                            <button className='plan-trial-button blue-button'>Current Plan</button>
                                            :
                                            <button onClick={(e) => handleSubmit(e,'monthly')} name="starter" className='plan-trial-button blue-button'>{pro == 1 ? 'Downgrade ':'Upgrade '} to Starter</button>
                                        }
                                        </div>
                                    </div>
                                </div>
                                {/* ultra plan */}
                                <div className='plan-card yellow-box-shadow'>
                                    <div>
                                        <div className='card-text-container'>
                                            <h3 className='plan-card-period cardhead-u mb-1'>Sender</h3>
                                            <h1 className='mb-0 plan-card-price price-u'>$79/mo</h1>
                                        </div>

                                        <div className='features-main-container'>
                                            <div className='features-list-container'>
                                            <div className='plan-feature-list'>
                                                    <img src={YellowCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>5000 Credits</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={YellowCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>1 Lead = 1 credit</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={YellowCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Pre-Made Templates</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='plan-button-container'>
                                    {(pro == 1 || pro == true) && (planType == 'ultra') ? 
                                            <button className='plan-trial-button yellow-button'>Current Plan</button>
                                            :
                                        <button onClick={(e) => handleSubmit(e,'monthly')} name="sender" className='plan-trial-button yellow-button'>Upgrade to Sender</button>
                                    }
                                    </div>
                                </div>
                            </div> 
                        }
                        {yearlyPlan &&
                        <div className='plan-cards-container' id="yearly-plans" >
                             {/* free plan */}
                             <div className='plan-card grey-box-shadow'>
                                    <div>
                                        <div className='card-text-container'>
                                            <h3 className='plan-card-period cardhead-u mb-1'>Free</h3>
                                            <h1 className='mb-0 plan-card-price price-u'>$0/mo</h1>
                                        </div>
                                        <div className='features-main-container'>
                                            <div className='features-list-container'>
                                            <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>100 Credits</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>1 Lead = 1 credit</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Pre-Made Templates</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='features-main-container'>
                                        <div className='plan-button-container'>
                                        {!pro ? 
                                            <button className='plan-trial-button blue-button clr-gray'>Current Plan</button>
                                            :
                                            <button name="free" className='plan-trial-button blue-button clr-gray' onClick={manageStripe}>Downgrade to Free</button>
                                        }
                                        </div>
                                    </div>
                            </div>
                            {/* pro plan */}
                            <div className='plan-card blue-box-shadow'>
                                    <div>
                                        <div className='card-text-container'>
                                            <h3 className='plan-card-period cardhead-u mb-1'>Pro</h3>
                                            <h1 className='mb-0 plan-card-price price-u'>$79/yr</h1>
                                        </div>
                                        <div className='features-main-container'>
                                            <div className='features-list-container'>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Email marketing</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Sell digital products</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Sell coaching calls</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Advanced analytics</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Sync-blocks</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>Publish blog posts</p>
                                                </div>
                                                <div className='plan-feature-list'>
                                                    <img src={BlueCheckboxIcon} alt="" />
                                                    <p className='feature-list-text list-u'>+ Everything in free</p>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className='features-main-container'>
                                        <div className='plan-button-container'>
                                        {(pro == 1 || pro == true) && (planType == 'pro' || !planType) ? 
                                            <button className='plan-trial-button blue-button'>Current Plan</button>
                                            :
                                            <button onClick={(e) => handleSubmit(e,'yearly')} name="pro" className='plan-trial-button blue-button'>{pro == 1 ? 'Downgrade ':'Upgrade '} to Starter</button>
                                        }
                                        </div>
                                    </div>
                            </div>
                            {/* ultra plan */}
                            <div className='plan-card yellow-box-shadow'>
                                <div>
                                    <div className='card-text-container'>
                                        <h3 className='plan-card-period cardhead-u mb-1'>Ultra</h3>
                                        <h1 className='mb-0 plan-card-price price-u'>$199/yr</h1>
                                    </div>

                                    <div className='features-main-container'>
                                        <div className='features-list-container'>
                                            <div className='plan-feature-list'>
                                                <img src={YellowCheckboxIcon} alt="" />
                                                <p className='feature-list-text list-u'>Custom Domain</p>
                                            </div>
                                            <div className='plan-feature-list'>
                                                <img src={YellowCheckboxIcon} alt="" />
                                                <p className='feature-list-text list-u'>Remove Zaap Branding</p>
                                            </div>
                                            <div className='plan-feature-list'>
                                                <img src={YellowCheckboxIcon} alt="" />
                                                <p className='feature-list-text list-u'>Invite Team Members</p>
                                            </div>
                                            <div className='plan-feature-list'>
                                                <img src={YellowCheckboxIcon} alt="" />
                                                <p className='feature-list-text list-u'>Priority support</p>
                                            </div>
                                            <div className='plan-feature-list'>
                                                <img src={YellowCheckboxIcon} alt="" />
                                                <p className='feature-list-text list-u'>+ Everything in Pro</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div className='plan-button-container'>
                                {(pro == 1 || pro == true) && (planType == 'ultra') ? 
                                        <button className='plan-trial-button yellow-button'>Current Plan</button>
                                        :
                                    <button onClick={(e) => handleSubmit(e,'yearly')} name="ultra" className='plan-trial-button yellow-button'>Upgrade to Sender</button>
                                }
                                </div>
                            </div>

                        </div>
                        }

                       
                    </div>
                   
            </div>

        
    )
}
export default NewUpgradePage;